<nz-form-item>
    <nz-form-label>{{customField.name}}</nz-form-label>
    <nz-form-control [ngSwitch]="customField.type">
        <quill-editor *ngSwitchCase="CustomFieldType.RichText" [(ngModel)]="value"></quill-editor>
        <textarea *ngSwitchCase="CustomFieldType.LongText" [(ngModel)]="value" nz-input></textarea>
    </nz-form-control>
</nz-form-item>